import {
    ActionType,
    getListAction,
    getInformationAction,
    getSupporterListAction,
    initSupporterListAction,
    selectCareRecipientAction, resetSelectedCareRecipientAction
} from "./actions";
import {
    CareRecipientJsonArray,
    CareRecipientJson
} from "../../../domain/care_recipient/CareRecipient";
import { SupportersJson } from "../../../domain/care_recipient/Supporters";
import { createSlice } from "@reduxjs/toolkit";

export type CareRecipientState = Readonly<{
    careRecipients: CareRecipientJsonArray[] | null,
    careRecipientInformation: CareRecipientJson | null,
    supporters: SupportersJson[],
    selectedCareRecipient: CareRecipientJsonArray | null,
    processing: number
}>;

const careRecipientInitialState: CareRecipientState = {
    careRecipients: null,
    careRecipientInformation: null,
    supporters: [],
    selectedCareRecipient: null,
    processing: 0
};

const slice = createSlice({
    name: ActionType.base,
    initialState: careRecipientInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(
                getListAction.pending,
                (state) => {
                    state.careRecipients = null;
                    state.processing += 1;
                }
            )
            .addCase(
                getListAction.fulfilled,
                (state, action) => {
                    const { payload } = action;
                    const { careRecipients } = payload;
                    state.careRecipients = careRecipients;
                    state.processing -= 1;
                }
            )
            .addCase(
                getListAction.rejected,
                (state) => {
                    state.processing -= 1;
                }
            )
            .addCase(
                getInformationAction.pending,
                (state) => {
                    state.careRecipientInformation = null;
                }
            )
            .addCase(
                getInformationAction.fulfilled,
                (state, action) => {
                    const { payload } = action;
                    const { careRecipientInformation } = payload;
                    state.careRecipientInformation = careRecipientInformation;
                }
            )
            .addCase(
                getInformationAction.rejected,
                () => {}
            )
            .addCase(
                initSupporterListAction,
                (state) => {
                    state.supporters = [];
                }
            )
            .addCase(
                getSupporterListAction.pending,
                () => {}
            )
            .addCase(
                getSupporterListAction.fulfilled,
                (state, action) => {
                    const { payload } = action;
                    const { supporters } = payload;
                    state.supporters.push(supporters);
                }
            )
            .addCase(
                getSupporterListAction.rejected,
                () => {}
            )
            .addCase(
                selectCareRecipientAction,
                (state, action) => {
                    state.selectedCareRecipient = {
                        ...action.payload,
                        alertPeriod: state.careRecipients?.find(careRecipient => careRecipient.id === action.payload.id)?.alertPeriod ?? null
                    };
                }
            ).addCase(
                resetSelectedCareRecipientAction,
                (state, _) => {
                    state.selectedCareRecipient = null;
                }
            );
    }
});

export const careRecipientReducer = slice.reducer;
